import { render, staticRenderFns } from "./tiaoartic.vue?vue&type=template&id=d9932dda&scoped=true&"
import script from "./tiaoartic.vue?vue&type=script&lang=js&"
export * from "./tiaoartic.vue?vue&type=script&lang=js&"
import style0 from "./tiaoartic.vue?vue&type=style&index=0&id=d9932dda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9932dda",
  null
  
)

export default component.exports